import { format } from 'date-fns';
import { z } from 'zod';

export const searchSchema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  voucherNumberStart: z.string().optional(),
  voucherNumberEnd: z.string().optional(),
  invoiceType: z.string().optional(),
  customerCode: z.string().optional(),
  employeeCode: z.string().optional(),
  description: z.string().optional(),
  materialCode: z.string().optional(),
  warehouseCode: z.string().optional(),
  batchCode: z.string().optional(),
  locationCode: z.string().optional(),
  objectCode: z.string().optional(),
  accountCode: z.string().optional(),
  unit: z.string().optional(),
  status: z.string().optional(),
  filterByUser: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const formSchema = z.object({
  ma_ngv: z.string().min(1),
  ngay_ct: z.string().optional(),
  ngay_lct: z.string().optional(),
  dien_giai: z.string().optional(),
  transfer_yn: z.boolean().optional(),
  ma_nt: z.string().optional(),
  ty_gia: z.coerce.number().optional(),
  status: z.string().optional(),
  tg_dd: z.boolean().optional(),
  cltg_yn: z.boolean().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_ngv: '1',
  ngay_ct: format(new Date(), 'yyyy-MM-dd'),
  ngay_lct: format(new Date(), 'yyyy-MM-dd'),
  dien_giai: '',
  transfer_yn: true,
  ma_nt: '',
  ty_gia: 1,
  status: '5',
  tg_dd: false,
  cltg_yn: false
};
